import { render, staticRenderFns } from "./contentNdCompare.vue?vue&type=template&id=5d58cd96&"
import script from "./contentNdCompare.vue?vue&type=script&lang=js&"
export * from "./contentNdCompare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CA5\\PhpstormProjects\\te-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5d58cd96', component.options)
    } else {
      api.reload('5d58cd96', component.options)
    }
    module.hot.accept("./contentNdCompare.vue?vue&type=template&id=5d58cd96&", function () {
      api.rerender('5d58cd96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Pages/page-part/contentNdCompare.vue"
export default component.exports